<template>
    <div :class="getUserTypeColor(id) + '--text'" class="align-center nowrapheader" style="max-width: 100%;">
        <v-icon v-if="!onlyText" size="18" :class="onlyIcon ? '' : 'mr-1 mb-1'" :color="getUserTypeColor(id)">
            {{ getUserTypeIcon(id) }}
        </v-icon>
        {{ onlyIcon ? '' : getUserTypeName(id) }}
    </div>
</template>


<script>
import UserTypeMixin from '@/helpers/Mixins/UserTypeMixin';

export default {
    name: 'UserTypeTextTemplate',
    props: {
        id: Number,
        onlyIcon: Boolean,
        onlyText: Boolean,
    },
    components: {},
    mixins: [UserTypeMixin],

    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>